// Curated personalization options for The Beacon (font + accent + heading color).
export const BEACON_FONTS = [
  { key: "cabinet", label: "Signal", css: "'Cabinet Grotesk', sans-serif" },
  { key: "satoshi", label: "Clean", css: "'Satoshi', sans-serif" },
  { key: "playfair", label: "Elegant", css: "'Playfair Display', serif" },
  { key: "fraunces", label: "Literary", css: "'Fraunces', serif" },
  { key: "dmserif", label: "Bold", css: "'DM Serif Display', serif" },
  { key: "space", label: "Modern", css: "'Space Grotesk', sans-serif" },
  { key: "poppins", label: "Friendly", css: "'Poppins', sans-serif" },
];

export const fontCss = (key) => (BEACON_FONTS.find((f) => f.key === key) || BEACON_FONTS[0]).css;

// One-tap "vibes", each sets font + accent + heading color together.
export const BEACON_PRESETS = [
  { key: "signal", label: "Signal", heading_font: "cabinet", accent_color: "#14A89A", heading_color: "#FFFFFF" },
  { key: "elegant", label: "Elegant", heading_font: "playfair", accent_color: "#C9A24B", heading_color: "#F3E7C4" },
  { key: "studio", label: "Bold Studio", heading_font: "dmserif", accent_color: "#E4572E", heading_color: "#FFFFFF" },
  { key: "modern", label: "Modern", heading_font: "space", accent_color: "#6C8EEF", heading_color: "#FFFFFF" },
  { key: "earthy", label: "Warm & Earthy", heading_font: "fraunces", accent_color: "#94A857", heading_color: "#ECE3CE" },
  { key: "playful", label: "Playful", heading_font: "poppins", accent_color: "#E86AA6", heading_color: "#FFFFFF" },
];

export const BANNER_SIZES = [
  { key: "slim", label: "Slim", ratio: 4, minH: 110 },
  { key: "standard", label: "Standard", ratio: 2.5, minH: 150 },
  { key: "tall", label: "Tall", ratio: 16 / 9, minH: 190 },
];
export const bannerSize = (key) => BANNER_SIZES.find((s) => s.key === key) || BANNER_SIZES[1];

export const SECTION_SIZES = [
  { key: "sm", label: "Small", cls: "text-lg" },
  { key: "md", label: "Medium", cls: "text-2xl" },
  { key: "lg", label: "Large", cls: "text-3xl" },
];

// Resolved look: empty tagline/section values fall back to the title's font & colour.
export const beaconLook = (b = {}) => {
  const hColor = b.heading_color || "#FFFFFF";
  return {
    accent: b.accent_color || "#14A89A",
    hFont: fontCss(b.heading_font), hColor,
    tFont: fontCss(b.tagline_font || b.heading_font), tColor: b.tagline_color || hColor,
    sFont: fontCss(b.section_font || b.heading_font), sColor: b.section_color || hColor,
    sSize: (SECTION_SIZES.find((s) => s.key === b.section_size) || SECTION_SIZES[1]).cls,
    banner: bannerSize(b.banner_size),
  };
};
